import {
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoCustomSelect,
    raikoCustomSelectItemGenerator,
    RaikoFlexFirstChildGrowOne,
    RaikoGridOneColumn,
    RaikoGridThreeColumn, RaikoGridTwoColumn,
    RaikoLabel,
    RaikoLabelType, RaikoMobileInputOutlined,
    RaikoNumberInputOutlined,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined,
    showErrorMessage,
    showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import React, {useEffect, useState} from "react";
import {LocationService} from "../../../serverService/provinceService/LocationService";
import {GameRegistrationService} from "../../../serverService/gameService/GameRegistrationService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {ServerErrorHandler} from "../../../service/errorHandler/ServerErrorHandler";
import style from "./GameRegistrantBasicInformation.module.scss"
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";
import {RaikoIcon} from "../../../raikoComponents/raikoIcon/RaikoIcon";
import {GenderDeterminationSelection} from "../../../pages/userInfromation/UserInformation";
import UserBanAccess from "../../../pages/userInfromation/UserBanAccess";
import {css} from "@emotion/css";

export default function GameRegistrantBasicInformation({registrantId}) {


    const locationService = new LocationService();
    const registrantService = new GameRegistrationService();

    const loading = new LoadingHelper(useLoadingDispatcher());


    useEffect(() => {
        getGameRegistrantBasicInformationFromServer()
        getProvincesFromServer()
    }, [registrantId]);

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [nationalCode, setNationalCode] = useState("");
    const [gender, setGender] = useState("");
    const [avatarUrl, setAvatarUrl] = useState("");
    const [displayName, setDisplayName] = useState("");

    const [selectedCity, setSelectedCity] = useState(-1)
    const [selectedProvince, setSelectedProvince] = useState(-1)

    const [provinces, setProvinces] = useState([])
    const [cities, setCities] = useState([])


    function getGameRegistrantBasicInformationFromServer() {
        loading.show()
        registrantService.getGameRegistrantBasicInformation(registrantId).then(
            response => {
                setFirstName(response.firstName)
                setLastName(response.lastName)
                setPhoneNumber(response.phoneNumber.toString().replace("989", "09"))
                setNationalCode(response.nationalCode)
                setGender(response.gender)

                setAvatarUrl(response.avatar.downloadUrl)
                setDisplayName(response.displayName)

                setSelectedProvince(response.city ? response.city.provinceId : -1)
                setSelectedCity(response.city ? response.city.id : -1)
            }
        ).catch(reason => {
            showServerErrorMessage(new ServerErrorHandler(reason).getMessage())
        }).finally(_ => {
            loading.hide()
        })
    }


    function getProvincesFromServer() {
        setProvinces([raikoCustomSelectItemGenerator(-1, "در حال دریافت استان ها ...")])
        locationService.getProvinces()
            .then(response => {
                setProvinces([])
                response.map((item) => {
                    setProvinces(prev => [
                        ...prev,
                        raikoCustomSelectItemGenerator(item.id, item.name)
                    ])
                })

                /*if (selectedProvince === -1)
                    setSelectedProvince(response[0].id)*/

            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
            setProvinces([raikoCustomSelectItemGenerator(-1, "خطا در دریافت استان ها...")])
        })
    }


    useEffect(() => {
        if (typeof selectedProvince !== 'undefined' && selectedProvince >= 0) {
            getCities()
        }
    }, [selectedProvince]);


    function getCities(cityId = selectedProvince) {
        setCities([raikoCustomSelectItemGenerator(-1, "در حال دریافت شهر ها ...")])
        locationService.getCity(cityId)
            .then(response => {
                setCities([])
                response.map((item) => {
                    setCities(prev => [
                        ...prev,
                        raikoCustomSelectItemGenerator(item.id, item.name)
                    ])
                })

                /*if (selectedCity === -1)
                    setSelectedCity(response[0].id)*/
            }).catch(reason => {

            showErrorMessage(detectServerErrorMessage(reason))
            setCities([raikoCustomSelectItemGenerator(-1, "خطا در دریافت شهر ها...")])

        })
    }


    return (
        <RaikoBaseContainer>
            <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
                <div className={style.baseInfoContainer}>
                    <RaikoBaseCardContainer
                        className={style.avatarContainer}
                    >

                        <img className={style.avatarImage} src={avatarUrl} alt=""/>
                        <RaikoGridOneColumn className={style.avatarInfoContainer}>
                            <RaikoFlexFirstChildGrowOne
                                className={css`
                                    gap: 2rem;
                                    justify-content: center;
                                    align-items: center;
                                    flex-wrap: nowrap;
                                `}>
                                <RaikoGridOneColumn className={css`gap: .25rem;`}>
                                    <RaikoLabel
                                        text={displayName && displayName.length > 0 ? displayName : "کاربر بی نام"}
                                        raikoLabelType={RaikoLabelType.TITLE}/>
                                    <RaikoLabel text={phoneNumber} raikoLabelType={RaikoLabelType.SUBTITLE}/>
                                </RaikoGridOneColumn>
                                <RaikoIcon
                                    icon={"ic-verified"}
                                    onClick={_ => {

                                    }}/>
                            </RaikoFlexFirstChildGrowOne>
                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>
                    <RaikoGridOneColumn
                        className={css`flex-grow: 1;`}
                    >

                        <RaikoBaseCardContainer

                            className={css`flex-grow: 1;`}
                        >
                            <RaikoSectionContainer
                                title={"اطلاعات پایه"}
                            >
                                <RaikoGridThreeColumn>
                                    <RaikoSimpleInputOutlined
                                        labelText={"نام"}
                                        setValue={setFirstName}
                                        value={firstName}
                                        disabled
                                    />

                                    <RaikoSimpleInputOutlined
                                        labelText={"نام خانوادگی"}
                                        setValue={setLastName}
                                        value={lastName}
                                        disabled
                                    />

                                    <RaikoSimpleInputOutlined
                                        labelText={"نام کاربری"}
                                        setValue={setDisplayName}
                                        value={displayName}
                                        disabled
                                    />

                                    <RaikoNumberInputOutlined
                                        maxLength={"10"}
                                        value={nationalCode}
                                        setValue={setNationalCode}
                                        labelText={"کد ملی"}
                                        disabled
                                    />

                                    <RaikoCustomSelect
                                        labelText={"جنسیت"}
                                        setValue={setGender}
                                        items={[
                                            raikoCustomSelectItemGenerator(GenderDeterminationSelection.MALE.key, GenderDeterminationSelection.MALE.name),
                                            raikoCustomSelectItemGenerator(GenderDeterminationSelection.FEMALE.key, GenderDeterminationSelection.FEMALE.name),
                                        ]}
                                        value={gender}
                                        disabled
                                    />

                                    <RaikoCustomSelect
                                        labelText={"استان"}
                                        items={provinces}
                                        value={selectedProvince}
                                        setValue={id => {
                                            setSelectedProvince(id)
                                            getCities(id)
                                        }}
                                        disabled

                                    />
                                    <RaikoCustomSelect
                                        labelText={"شهر"}
                                        items={cities}
                                        value={selectedCity}
                                        setValue={id => {
                                            setSelectedCity(id)
                                        }}
                                        disabled

                                    />
                                </RaikoGridThreeColumn>
                            </RaikoSectionContainer>
                        </RaikoBaseCardContainer>


                    </RaikoGridOneColumn>

                </div>


            </RaikoGridOneColumn>
        </RaikoBaseContainer>
    )
}